import { FunctionComponent } from 'react'
import DashboardLayout from '../../components/layout/layout'
import { Box, Button, Grid, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const OnlineOrderEntryOrderSendConfirm: FunctionComponent = () => {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate('/order-management-system');
  };

  return (
    <div className="online-order-entry-page">
      <DashboardLayout title={"Orders Management"} initialBreadcrumbs={"Channel Partners"} levelBreadcrumbs={"Online Order Entry"} breadcrumbs={'Send Order Done'} activeMenu={'oms'}>
      <Grid container sx={{ padding: '0px 20px 20px 0px' }}>
        <Grid size={8}>
          <Typography variant="h6">
            Your order has been received.
          </Typography>
          <Button variant="contained" sx={{ backgroundColor: '#c3183c', padding: '6px 25px !important', marginTop: '25px' }} onClick={handleNext}>
            RETURN TO THE EXTRANET
          </Button>
        </Grid>
        <Grid size={4}>
          <Box
            sx={{
              width: 0,
              height: 0,
              borderLeft: '60px solid transparent',
              borderRight: '60px solid transparent',
              borderBottom: '94.6px solid #dc0f4b',
            }}
          />
        </Grid>
      </Grid>
    </DashboardLayout>
    </div>
  )
}

export default OnlineOrderEntryOrderSendConfirm